import * as Colors from "../../../../../../../globalStyles/environmentColors";

export const body = {
    minHeight: "100vh",
    backgroundColor: Colors.background
};
